import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await api.get('/api/me', {
        skipAuthRedirect: true
      });
      setUser(response.data);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (credentials) => {
    const formData = new FormData();
    formData.append('email_or_username', credentials.email_or_username);
    formData.append('password', credentials.password);
    
    const response = await api.post('/login', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    
    await checkAuth();
    return response;
  };

  const register = async (userData) => {
    const formData = new FormData();
    Object.keys(userData).forEach(key => {
      formData.append(key, userData[key]);
    });
    
    const response = await api.post('/register', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    
    return response;
  };

  const logout = async () => {
    try {
      await api.post('/api/logout', {}, {
        skipAuthRedirect: true
      });
    } catch (error) {
      console.warn('Logout request failed, clearing local session anyway.', error);
    } finally {
      setUser(null);
      window.location.href = '/login';
    }
  };

  const value = {
    user,
    loading,
    login,
    register,
    logout,
    checkAuth
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
